<template>
    <k-panel title="买家评价">
        <div>
            <k-cell size="small">
                <span class="cl-desc">综合评分：</span>
                <k-rate
                        v-model="star"
                        color="#f44"
                        void-icon="star"
                        void-color="#eee"
                        readonly
                        style="display: inline-block; vertical-align: middle;"
                />
            </k-cell>
            <k-cell size="small">
                <span class="cl-desc">服务态度：</span>
                {{server || '非常满意'}}
            </k-cell>
            <k-cell size="small">
                <span class="cl-desc">鉴定速度：</span>
                {{speed || '非常满意'}}
            </k-cell>
            <k-hr />
        </div>
    </k-panel>
</template>

<script>
    export default {
        name: "evaluate-info",
        props : ["star", "server", "speed"]
    }
</script>

<style scoped>

</style>